import "./data/yup-validation";
import React from "react";
import ReactDOM from "react-dom";
import { navigate } from "@reach/router";
import DevTools from "utils/dev-tools";
import Settings from "./settings";
import "./styles/main.scss";
import App from "./router";


// expose modules for testing with Cypress
if (Settings.env === "development" || Settings.env === "test") {
  window.navigate = navigate;
}

window.devTools = DevTools;
if (Settings.env === "development" || Settings.env === "test") {
  DevTools.enableDebug();
}

ReactDOM.render(<App />, document.getElementById("root"));
